import CustomGrid from "./CustomGrid";

export default CustomGrid;



// WEBPACK FOOTER //
// ./src/commonComponents/CustomGrid/index.js